import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-safe-icon',
  templateUrl: './shopping-safe.component.html'
})
export class ShoppingSafeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
